import Styles from './AutopilotProUpgradeButton.module.scss'
import { Text } from 'blaze-ui/Text/Text'
import dayjs from 'dayjs'
import { useCurrentBrandPlan } from 'hooks/queries/brandPlans/useCurrentBrandPlan'
import { useBrandPlanSchedules } from 'hooks/queries/schedules/useBrandPlanSchedules'
import { useAutopilotLimits } from 'hooks/useAutopilotLimits'
import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'
import React, { useMemo } from 'react'
import { calculateTotalPostCount } from 'screens/Calendar/WeekViewV2/BatchContentActions/Modals/AddMoreContentModal/utils'
import { collectResults } from 'utils/query'

export const FreemiumUsageTextUI = ({
  totalPostCount,
  maxPostsPerChannel,
  maxChannels,
}: {
  totalPostCount: number
  maxPostsPerChannel: number
  maxChannels: number
}): React.ReactElement => {
  return (
    <div className={Styles.freemiumUsageText}>
      <Text variant="metadata" color="var(--dark-80)">{`Posts this week`}</Text>
      <Text variant="metadata" color="var(--dark-40)">
        {totalPostCount}/{maxPostsPerChannel * maxChannels}
      </Text>
    </div>
  )
}

export const FreemiumUsageText = (): React.ReactElement => {
  const { maxChannels, maxPostsPerChannel } = useAutopilotLimits()
  const workspace = useCurrentWorkspace()
  const { data: brandPlan } = useCurrentBrandPlan()
  const schedulesQuery = useBrandPlanSchedules(
    brandPlan?.id
      ? {
          brandPlanId: brandPlan.id,
          start_date: dayjs().format('YYYY-MM-DD'),
        }
      : { brandPlanId: -1, start_date: '' },
    { enabled: !!brandPlan?.id },
  )
  const schedules = collectResults(schedulesQuery, (data) => data.schedules)

  const totalPostCount = useMemo(() => {
    const currentSchedule = schedules.find((schedule) => schedule.is_current)
    return calculateTotalPostCount(currentSchedule)
  }, [schedules])

  if (workspace?.is_ap_freemium)
    return (
      <FreemiumUsageTextUI
        totalPostCount={totalPostCount}
        maxPostsPerChannel={maxPostsPerChannel}
        maxChannels={maxChannels}
      />
    )

  return <></>
}
